import { makeStyles, fade } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    height: theme.spacing(7),
    paddingRight: theme.spacing(10),
    [theme.breakpoints.up('sm')]: {
      paddingRight: theme.spacing(12),
    },
    [theme.breakpoints.up('sm')]: {
      '&:hover': {
        backgroundColor: theme.palette.primary.lighter,
        boxShadow: theme.shadows[2],
        zIndex: theme.zIndex.mobileStepper,
      },
    },
  },
  isChecked: {
    backgroundColor: `${theme.palette.primary.lighter} !important`,
  },
  item: {
    [theme.breakpoints.up('sm')]: {
      '&:hover $deleteButton': {
        display: 'block',
      },
    },
  },
  itemCheckboxWrapper: {
    minWidth: theme.spacing(3),
    [theme.breakpoints.up('sm')]: {
      minWidth: theme.spacing(7),
    },
  },
  itemCheckbox: {
    [theme.breakpoints.up('sm')]: {
      margin: 0,
    },
  },
  itemText: {
    color: theme.palette.primary.main,
  },
  primary: {
    '.MuiListItem-button &': {
      color: theme.palette.primary.main,
      fontWeight: 600,
    },
  },
  isPending: {
    color: theme.palette.grey[200],
  },
  itemButton: {
    cursor: 'default',
  },
  itemIcon: {
    fontSize: '1rem',
  },
  itemIconBig: {
    fontSize: '1.5rem',
  },
  iconGold: {
    fontSize: '1em',
    color: theme.palette.secondary.dark,
  },
  iconGrey: {
    color: fade(theme.palette.grey[200], 0.6),
  },
  iconSuccess: {
    color: theme.palette.success.dark,
  },
  itemActions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    minWidth: theme.spacing(10),
    right: theme.spacing(3),
    zIndex: theme.zIndex.speedDial,
    '& > .MuiButtonBase-root': {
      width: theme.spacing(6),
      height: theme.spacing(6),
      '& + .MuiButtonBase-root': {
        [theme.breakpoints.up('sm')]: {
          marginLeft: theme.spacing(1),
        },
      },
    },
  },
  deleteButton: {
    display: 'none',
    color: theme.palette.primary.main,
    '&:hover': {
      color: theme.palette.primary.light,
    },
  },
}))

export default useStyles
